export interface BaseSubsType {
  "information": boolean,
  "failures": boolean,
  "warnings": boolean,
  "updates": boolean,
  "softwareRelease": boolean,
}

export interface SubscriptionResponse extends BaseSubsType {
  "id": string,
  "email"?: string,
  "createdAt"?: string,
  "createdBy"?: string,
  "modifiedAt"?: string,
  "modifiedBy"?: string
}

export interface SubscribePayload extends BaseSubsType {
  id?: string, 
}

export enum SubscribeTypes {
  information = 'information',
  failures = 'failures',
  warnings = 'warnings',
  updates = 'updates',
  softwareRelease = 'softwareRelease',
}